import { Injectable } from '@angular/core';
import { QueueBaseService } from '@core/services/queue/queue-base.service';
import { map, Observable } from 'rxjs';
import { EvaluateData } from '@shared/models/service-line-routing.model';
import { ProductName } from '@core/constants';

@Injectable({
  providedIn: 'root',
})
export class CaseQueueService extends QueueBaseService {
  fragment = `dmepos/lob/${this.platformService.currentLineOfBusiness$.value?.lineOfBusinessId}/authorizationCaseQueues`;
  uniqueKey = 'authorizationCaseQueueId';

  override getEvaluateQueue(id: string): Observable<EvaluateData> {
    return super.getEvaluateQueue(id).pipe(
      map((data) => {
        if (this.productName.value === ProductName.DMEPOS_MA && data) {
          delete data.queueRequirements?.['MCO'];
          delete data.ruleRequirements?.['MCOs'];
        }

        return data;
      })
    );
  }
}
